export const PATH = {
  HIRE_POINTS_LIST: '/hirepoint/list',
  HIRE_POINTS_ADD: '/hirepoint/add',
  AVAILABLE_VEHICLE_LIST: '/vehicle/availableList',
  AVAILABLE_EQUIPMENT_LIST: '/extra/availableList',
  LOCATIONS_FILTERS: '/hirepoint/filtersData',
}
